/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { 
    Heading,
    Flex,
    Circle,
    Box,
    Image,
    Icon,
    chakra,
    Tooltip,
    SimpleGrid,
    VStack,
    Text,
    Button,
    useToast,
    Spinner
} from "@chakra-ui/react";
import axios from 'axios';
import { FiShoppingCart } from 'react-icons/fi';
import CommonVars from "../components/CommonVars";
import { useParams } from "react-router-dom";

function CategoryScreen () {
    const [catProducts, setCatProducts] = useState('');
    const [loading, setLoading] = useState(false);

    const categoryid = useParams().categoryid;

    const catUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    const catToken = localStorage.getItem('token');
    let role = '';
    if(catUserDetails !== null){
        role = catUserDetails.role;
    }

    // get all products by category
    const getProductByCat = async () => {
        axios.get(`${CommonVars.API_URL}/category/${categoryid}/products`)
        .then((res) => {
            setLoading(true);
            console.log(res.data);
            setCatProducts(res.data);
        })
        .catch((err) => {
            console.log(err);
        })
    }

    useEffect(() => {
        getProductByCat();
    }, []);

    const aCatProducts = [];

    for (var i = 0; i < catProducts.length; i++)
    {
        aCatProducts.push(
            <Box
                key={catProducts[i].productid}
                borderWidth="1px"
                rounded="lg"
                shadow="lg"
                position="relative"
                // w={}
            >
                <Circle
                    size="10px"
                    position="absolute"
                    top={2}
                    right={2}
                    bg="red.200"
                />

                <a href={'/products/' + catProducts[i].productid}>
                    <Image
                        boxSize="290px"
                        src={catProducts[i].products_img_url}
                        alt={`Picture of ${catProducts[i].name}`}
                        roundedTop="lg"
                        mx="auto"
                        _hover={{ transform: "scale(1.05)" }} transition={"1s ease-in-out"}
                        objectFit={"cover"}
                    />
                </a>

                <Box p="5">
                    <Flex mt="1" justifyContent="space-between" alignContent="center">
                        <Box
                            fontSize="xl"
                            fontWeight="semibold"
                            as="h4"
                            lineHeight="tight"
                            istruncated="true"
                        >
                            <chakra.a href={'/products/' + catProducts[i].productid} display={'flex'}>
                                {catProducts[i].name}
                            </chakra.a>
                        </Box>
                        <Tooltip
                            label="Add to cart"
                            bg="white"
                            placement={'top'}
                            color={'gray.800'}
                            fontSize={'1.2em'}
                        >
                            <chakra.a href={'/products/' + catProducts[i].productid} display={'flex'}>
                                <Icon as={FiShoppingCart} h={6} w={6} alignSelf={'center'} />
                            </chakra.a>
                        </Tooltip>
                    </Flex>

                    <VStack align={'left'}>
                        <Box fontSize="xl">
                            <Text>${catProducts[i].price}</Text>
                        </Box>
                    </VStack>
                </Box>
            </Box>
        );
    };

    // set toast
    const toast = useToast();
    const id = 'disCode-toast';

    const deleteCategory = (e) => {
        e.preventDefault();
        
        axios.delete(`${CommonVars.API_URL}/category/${categoryid}`, 
            { headers: { Authorization: `Bearer ${catToken}` } }
        )
            .then(() => {
                if (!toast.isActive(id)) {
                    toast({
                        id,
                        title: 'Success!',
                        description: `Category successfully deleted!`,
                        status: 'success',
                        position: 'top',
                        duration: 3000,
                        isClosable: true,
                    });
                };
                setTimeout(() => {
                    window.location.replace('/');
                }, 1000);
            })
            .catch((error) => {
                console.log(error);
                if (!toast.isActive(id)) {
                    toast({
                        id,
                        title: 'Error!',
                        description: `Some error occurred trying to delete category!`,
                        status: 'error',
                        position: 'top',
                        duration: 3000,
                        isClosable: true,
                    });
                };
            });
    };

    return(
        <>
        {
            loading !== true ? 
            <Flex 
                minH={'70vh'}
                justify={'center'}
                bg={'#F4F4F4'}
            >
                <Flex align={'center'} justify={'center'}>
                    <VStack align="center">
                            <Spinner thickness='9px' speed='0.75s' emptyColor='gray.200' color='blue.500' boxSize={24}/>
                            <Text fontSize={18} pt={6}>Loading Products...</Text>
                    </VStack>
                </Flex> 
            </Flex> : 
            <Box
            px={"3.5rem"}
            bg={"#f4f4f4"}
        >
            <Box 
                px={{ lg: 12, xl: 24 }}
                py={{ base: 6, md: 8, lg: 10 }}
            >
                <Heading
                    pb={10}
                >
                    Our Products
                </Heading>
                <SimpleGrid
                    columns={{ sm: 1, md: 2, lg: 3, xl: 4}}
                    columnGap={{ base: 4, md: 6 }}
                    rowGap={{ base: 8, md: 10}}
                    alignContent="center"
                    // px={24}
                >
                    {aCatProducts}
                </SimpleGrid>
            </Box>
            <Box
                textAlign={"center"}
                pb={10}
            >
                {role !== "admin" ?
                    null :
                    <Button 
                        type={'submit'} 
                        onClick={deleteCategory}
                        bg = 'black'
                        color = 'white'
                        border = '2px solid black'
                        _hover = {{
                            bg: 'white',
                            color: 'black',
                            border: '2px solid black'
                        }}
                    >
                        Delete Category
                    </Button>
                }
            </Box>
        </Box>
        }
        </>
        
    )
}

export default CategoryScreen;